import { useFormActaStore } from "../store/formActaStore";
import { cargaBarrios, cargaTipos } from "../services/formPasos.service";

const { setBarrios, setTipos } = useFormActaStore.getState();

export const handlerCargaBarrios = async () => {
  const result = await cargaBarrios();
  if (result) {
    setBarrios(result);
  }
};

export const handlerCargaTipos = async () => {
  const result = await cargaTipos();
  if (result) {
    setTipos(result);
  }
};
